import React from "react";
import { Box } from "@mui/material";
import Navbar from "./Navbar";
import Banner from "./Banner";
import { Outlet, useLocation } from "react-router-dom";
import useWebchatScript from "../../hooks/useWebchatScript";
export default function Layout() {
  const location = useLocation();
  const hideBanner = location.pathname === "/CookiePolicy"
  useWebchatScript();
  return (
    <Box>
      <Navbar />
      <Box sx={{ mt: "80px" }}>
        {!hideBanner && 
          <Banner />
        }
      </Box>
      <Outlet />
    </Box>
  );
}
